import DrawerNavStandard from './DrawerNavStandard';
import ScrollLock from '../utils/ScrollLock';

export default class DrawerNav extends DrawerNavStandard {
  constructor(settings) {
    super(settings);

    this.menuLinks = this.drawerNav.querySelectorAll('[data-drawer-link-tier-1]');
  }

  open() {
    ScrollLock.lock(this.drawerNav);
    super.open();

    this.menuLinks.forEach((menuLink, i) => {
      // Delay is staggered for each menu item
      const delay = 600 + (i * 100);
      setTimeout(() => menuLink.classList.add('drawer-menu__tier-1-link--open'), delay);
    });
  }

  close() {
    ScrollLock.unlock();
    super.close();

    this.menuLinks.forEach(menuLink => {
      menuLink.classList.remove('drawer-menu__tier-1-link--open');
    });
  }
}
